import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import axios from '../api/axiosConfig';
import _ from 'lodash';
import { useAuth } from '../context/AuthContext';
// emoji png
import emoji1 from '../assets/emojis/1.svg';
import emoji2 from '../assets/emojis/2.svg';
import emoji3 from '../assets/emojis/3.svg';
import emoji4 from '../assets/emojis/4.svg';
import emoji5 from '../assets/emojis/5.svg';
import emoji6 from '../assets/emojis/6.svg';
import emoji7 from '../assets/emojis/7.svg';

import dailyIcon from '../assets/daily.svg';

const DailyJournalPage: React.FC = () => {
  const { checkSubmissionStatus } = useAuth();
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [selectedEmotion, setSelectedEmotion] = useState<number | null>(null);
  const emotionOptions = [
    {
      name: emoji1,
      ment: '깊은 슬픔이나 지침이 느껴지는 상태예요.\n마음이 무겁고, 감정을 다루기 힘들 정도로 지쳐 있을 수 있습니다.',
      level: 1,
      color: '#4a90e2',
    },
    {
      name: emoji2,
      ment: '불안, 짜증, 혹은 답답함이 쌓인 상태예요.\n상황이 뜻대로 되지 않아 스트레스나 분노가 느껴질 수 있습니다.',
      level: 2,
      color: '#50c878',
    },
    {
      name: emoji3,
      ment: '서운함이나 상처, 외로움을 느끼는 상태예요.\n누군가의 말이나 행동이 마음에 오래 남아있을 수도 있습니다.',
      level: 3,
      color: '#7ed321',
    },
    {
      name: emoji4,
      ment: '감정의 강도가 낮은 중립적인 상태예요.\n특별히 기쁘지도, 슬프지도 않은 평범한 하루일 수 있습니다.',
      level: 4,
      color: '#9b9b9b',
    },
    {
      name: emoji5,
      ment: '비교적 안정되고 편안한 상태예요.\n일상 속 작은 즐거움이나 만족을 느끼고 있을 가능성이 높습니다.',
      level: 5,
      color: '#f5a623',
    },
    {
      name: emoji6,
      ment: '따뜻함과 행복감이 느껴지는 상태예요.\n주변 사람이나 상황에 대해 감사와 애정을 느끼고 있을 수 있습니다.',
      level: 6,
      color: '#ff8c69',
    },
    {
      name: emoji7,
      ment: `기쁨, 사랑, 설렘 같은 긍정적인 감정이 가득한 상태예요.\n마음이 활짝 열리고, 에너지가 넘치는 순간입니다.`,
      level: 7,
      color: '#d0021b',
    },
  ];

  const handleSubmit = async () => {
    if (selectedEmotion === null) {
      alert('감정을 선택해주세요.');
      return;
    }
    try {
      const emotionLevel = emotionOptions[selectedEmotion].level;
      await axios.post('/api/daily-journals', { content, emotion: emotionLevel });
      alert('저장되었습니다.');
      await checkSubmissionStatus(); // 제출 상태를 업데이트합니다.
      navigate('/'); // 홈페이지로 이동합니다.
    } catch (error) {
      console.error('Failed to submit journal:', error);
      alert('저장에 실패했습니다.');
    }
  };

  const handleEmojiClick = (index: number) => {
    if (selectedEmotion === index) {
      setSelectedEmotion(null);
      return;
    }
    setSelectedEmotion(index);
  };

  const selectedEmotionData = selectedEmotion !== null ? emotionOptions[selectedEmotion] : null;

  return (
    <div className="daily-journal-page-container">
      <div className="page-header">
        <img src={dailyIcon} alt="Daily Journal Icon" className="page-header__icon" />
        <h2 className="page-header__title">오늘 하루는 어땠나요?</h2>
        <p className="page-header__subtitle">오늘 하루, 당신의 마음은 어떤 표정인가요?</p>
      </div>
      <div className="journal-card">
        <div className="emoji-container">
          {emotionOptions.map((emotion, index) => (
            <img
              key={index}
              src={emotion.name}
              alt="emoji"
              className={selectedEmotion === index ? 'selected' : ''}
              onClick={() => handleEmojiClick(index)}
            />
          ))}
        </div>
        <div className="emoji-ment-container">
          {selectedEmotionData && (
            <p
              key={selectedEmotion}
              className="emoji-ment"
              style={{ color: selectedEmotionData.color }}
            >
              {selectedEmotionData.ment}
            </p>
          )}
        </div>
        <div className="editor-container" translate="no">
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            placeholder="자유롭게 하루를 기록하고, 감정을 정리해보세요.(선택)"
          />
        </div>
        <button
          onClick={handleSubmit}
          className="submit-button"
          disabled={selectedEmotion === null}
        >
          기록하기
        </button>
      </div>
    </div>
  );
};

export default DailyJournalPage;
